import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { Upload, FileText } from 'lucide-react'

interface UploadZoneProps {
  onUpload: (file: File) => void
  isUploading: boolean
}

export function UploadZone({ onUpload, isUploading }: UploadZoneProps) {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0 && acceptedFiles[0]) {
      onUpload(acceptedFiles[0])
    }
  }, [onUpload])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'text/csv': ['.csv']
    },
    multiple: false,
    disabled: isUploading
  })

  return (
    <div
      {...getRootProps()}
      className={`
        border-2 border-dashed rounded-2xl p-16 text-center cursor-pointer
        transition-all duration-300
        ${isDragActive ? 'border-primary bg-primary/10 scale-[1.02]' : 'border-border bg-card'}
        ${isUploading ? 'opacity-50 cursor-not-allowed' : 'hover:border-primary hover:bg-primary/5 hover:shadow-lg'}
      `}
    >
      <input {...getInputProps()} />

      <div className="flex flex-col items-center gap-6">
        {isUploading ? (
          <>
            <div className="h-16 w-16 animate-spin rounded-full border-4 border-primary border-t-transparent" />
            <p className="text-xl font-semibold">アップロード中...</p>
          </>
        ) : (
          <>
            {isDragActive ? (
              <FileText className="h-20 w-20 text-primary" />
            ) : (
              <Upload className="h-20 w-20 text-muted-foreground" />
            )}

            <div>
              <p className="text-xl font-semibold mb-2">
                {isDragActive
                  ? 'ここにドロップしてください'
                  : 'CSVファイルをドラッグ&ドロップ'}
              </p>
              <p className="text-sm text-muted-foreground mb-6">
                または クリックしてファイルを選択
              </p>
              <button
                type="button"
                className="netflix-gradient px-6 py-3 text-white rounded-lg font-medium hover:opacity-90 transition-opacity"
              >
                ファイルを選択
              </button>
            </div>

            <div className="text-xs text-muted-foreground mt-2">
              <p>対応形式: Netflix視聴履歴CSV (.csv)</p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
